import React from "react";
import { formatValidInput } from "../../helpers/FormatHelper";
import NumberInput from "../shared/NumberInput";
import { Checkbox } from "antd";
import { useState } from "react";
import { useEffect } from "react";
import { getPendingAmountStyle } from "./OrderService";
import { use } from "react";

export function OrderInformationDenomination({rowKey, denominations, currencyID, onBlurDenominationValue, valid, mixedNotes, lockedSide, onUpdateMixedNotes, amountEnteredByUser, sellScale, workingAmount, onUpdateDenominationFeeValue, allowDenominationFees}){

     const [localValues, setLocalValues] = useState([]);     
     const [localFeeValues, setLocalFeeValues] = useState([]);     

    useEffect(()=>{
    const values = [];
    const fees = [];
    denominations.forEach((d)=>{
        values.push(d.NoNotes);
        fees.push(d.DenominationFee??0);
    });
    setLocalValues(values);
    setLocalFeeValues(fees);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[mixedNotes, currencyID])

    useEffect(()=>{

    const fees = [];
    denominations.forEach((d)=>{
        fees.push(d.DenominationFee??0);
    });
    setLocalFeeValues(fees);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[denominations])

    useEffect(() => {
        let usedAmount = denominations.reduce((sum, d, idx) => {
            return sum + d.DenominationValue * (localValues[idx] ?? 0);
        }, 0);
        if (amountEnteredByUser < usedAmount) {
            const updatedValues = [...localValues];
            for (let i = updatedValues.length - 1; i >= 0 && usedAmount > amountEnteredByUser; i--) {
                if (updatedValues[i] > 0) {
                    usedAmount -= denominations[i].DenominationValue * updatedValues[i];
                    updatedValues[i] = 0;
                }
            }
            setLocalValues(updatedValues);
            onBlurDenominationValue(updatedValues)
        }
    }, [amountEnteredByUser])

    const onChangeDenominationValueNoValidation = (value, index) => {        
        value = value ?? 0;
        const values = localValues;
        localValues[index] = Number(value);
        setLocalValues(values);
    }

    const onChangeDenominationValue = (value, index, denominationValue) => {
        const numValue = value ?? 0;
        if (amountEnteredByUser === 0) {
            onChangeDenominationValueNoValidation(numValue, index);
            return;
        }
        // Sum of all other denominations
        const usedAmount = denominations.reduce((sum, d, idx) => {
            if (idx === index) return sum;
            return sum + d.DenominationValue * (d.NoNotes ?? 0);
        }, 0);

        const maxAllowed = amountEnteredByUser - usedAmount;
        const finalValue = numValue * denominationValue > maxAllowed ? 0 : numValue;

        const updatedValues = [...localValues];
        updatedValues[index] = finalValue;

        setLocalValues(updatedValues);
    }

    const onChangeDenominationFeeValue = (value, index) => {

        const updatedFeeValues = [...localFeeValues];
        updatedFeeValues[index] = value;

        setLocalFeeValues(updatedFeeValues);
        onUpdateDenominationFeeValue(value, index)
    }

    const onBlurDenomination = () => {
        onBlurDenominationValue(localValues);
    }

    const getDenominations = () =>{

    const listDenominations = [];
    listDenominations.push(<td>{lockedSide.toLowerCase() === 'sell' && <Checkbox id={`orderden-check-${rowKey}`} key={`orderden-check-${rowKey}`} checked={mixedNotes} onChange={(e)=>onUpdateMixedNotes(e.target.checked)} >{'Mixed Notes'}</Checkbox>}</td>)
    if(denominations)
    {
    denominations.forEach((d, index)=>{
        listDenominations.push(<td id={`orderden-${rowKey}-${index}`} key ={`orderden-${rowKey}-${index}`} >
          <label className="uk-form-label" style={{marginRight:'5px'}} htmlFor={`den-${rowKey}-${index}`}>{`${d.DenominationDescription} x `}</label>
          <NumberInput id={`den-${rowKey}-${index}`} className={`uk-denomination ${formatValidInput(d.valid && valid)}`} value={localValues[index] > 0 ? localValues[index] :''}
                      onBlur={onBlurDenomination} onChange ={(event) => {onChangeDenominationValue(event.target.value, index, d.DenominationValue);}} scale={0} disabled={mixedNotes}/>
        </td>)
    })}

    return listDenominations;
   } 

   const getFees = () =>{
        const listFees = [];
        listFees.push(<td style={{textAlign:'center'}}>Fees</td>)
        if(denominations)
        {
        denominations.forEach((d, index)=>{
            listFees.push(<td id={`orderdenfee-${rowKey}-${index}`} key ={`orderdenfee-${rowKey}-${index}`} style={{textAlign:'right'}} >
            <NumberInput id={`denfee-${rowKey}-${index}`} className={`uk-denomination ${formatValidInput(true)}`} value={localFeeValues[index] > 0 ? localFeeValues[index] :''}
                        onChange ={(event) => {onChangeDenominationFeeValue(event.target.value, index);}} scale={2} type="Currency" />
            </td>)
        })}

        return listFees;
   }

   return <table>
        <tr>
            {getDenominations()}
            {!mixedNotes && (amountEnteredByUser - workingAmount) > 0 && <td id={`orderden-${rowKey}-amountEnteredByUser`} key={`orderden-${rowKey}-amountEnteredByUser`} >
                <label className="uk-form-label" style={{ marginRight: '5px' }} htmlFor={`den-${rowKey}-amountEnteredByUser`}></label>
                <NumberInput type="Currency" id={`den-${rowKey}-amountEnteredByUser`} className='uk-denomination uk-input' value={amountEnteredByUser - workingAmount}
                    scale={sellScale} disabled={true} style={getPendingAmountStyle(amountEnteredByUser - workingAmount)} />
            </td>}
        </tr>
        <tr>
            {allowDenominationFees && getFees()}
        </tr>
    </table>
}

export default OrderInformationDenomination